import React, { useState } from 'react';
import classnames from 'classnames';

import RemixArrowDownLineSVG from '../svg/icons/remix-arrow-down-line.svg';
import Pill from './Pill';
import PricingFeatureBoolean from './PricingFeatureBoolean';
import PricingFeatureNumeric from './PricingFeatureNumeric';
import PricingFeatureText from './PricingFeatureText';

const PricingFeatureTable = ({
  features,
  open: defaultOpen = true,
  plans,
  title,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggleOpen = () => setOpen((open) => !open);

  return (
    <table className="w-full mb-6">
      <thead>
        <tr className="bg-whisper flex items-center justify-between rounded">
          <th className="px-3 w-full">
            <button
              className="flex items-center w-full focus:outline-none"
              onClick={toggleOpen}
            >
              <span className="flex-1 py-4 font-semibold text-left tracking-tight">
                {title}
              </span>
              <RemixArrowDownLineSVG
                className={classnames(
                  'duration-150 w-5 transform text-rock-blue transition-transform',
                  {
                    'rotate-180': open,
                  }
                )}
              />
            </button>
          </th>
        </tr>
      </thead>
      <tbody
        className={classnames({
          hidden: !open,
        })}
      >
        {features.map(
          ({ id: featureId, comingSoon, description, name }, index) => (
            <tr className="grid grid-cols-12 items-center" key={index}>
              <td className="col-span-12 md:col-span-4 flex md:flex-col items-center md:items-start font-medium px-3 py-3 md:py-4 text-left text-sm md:text-base border-b md:border-b-0 mb-2 md:mb-0">
                <div className="flex flex-col">
                  <div className="flex items-baseline">
                    <p className="font-medium">{name}</p>
                    {comingSoon && (
                      <Pill colour="black" label="Soon" size="small" />
                    )}
                  </div>
                  <span className="text-light-haiti text-xs">
                    {description}
                  </span>
                </div>
              </td>
              {plans.map((plan, index) => {
                const planFeatureEntry = plan.entries.find(
                  ({ planFeature: { id: planFeatureId } }) =>
                    planFeatureId === featureId
                );

                if (!planFeatureEntry) return null;

                const cellComponent = (featureType) => {
                  switch (featureType) {
                    case 'GraphCMS_PlanEntryBoolean':
                    default:
                      return <PricingFeatureBoolean {...planFeatureEntry} />;
                    case 'GraphCMS_PlanEntryNumeric':
                      return <PricingFeatureNumeric {...planFeatureEntry} />;
                    case 'GraphCMS_PlanEntryText':
                      return <PricingFeatureText {...planFeatureEntry} />;
                  }
                };

                return (
                  <td
                    className="col-span-3 md:col-span-2 font-medium px-3 py-3"
                    key={index}
                  >
                    {cellComponent(planFeatureEntry.__typename)}
                  </td>
                );
              })}
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export default PricingFeatureTable;
